/* eslint-disable max-len */
import { Card, Col, Row } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import identifikaceEmitenta from 'services/akcionar/emise/identifikaceEmitenta';
import podaneZadostiApi, { IPodaneZadosti } from 'services/akcionar/emise/podaneZadosti';
import { ETypZadosti, zruseniZadosti } from 'services/akcionar/emise/zruseniZadosti';
import fileDownload from 'services/fileDownload';
import { vyjadreniCdcpIsinApi } from 'services/spravaEmitenta/vyjadreniCdcp';

import { EZadostStatus } from 'enums/amlz/zadostStatus';
import { EStav } from 'enums/isin/eStav';
import routePathEnum from 'enums/routePathEnum';

const EmisePrehled: React.FC = () => {
    const { navigateWorkaround } = useNavigateWorkaround();
    const { setLevel } = useProfily();
    const { aktivniFirma } = useContext(Context);
    const [emisePrehled, setEmisePrehled] = useState<IPodaneZadosti[]>([]);
    const [errStatus, setErrStatus] = useState<number>();
    const [loading, setLoading] = useState<boolean>(false);
    const [refetchData, setRefetchData] = useState<boolean>(false);
    const [modalMessage, setModalMessage] = useState<string>('');

    useEffect(() => {
        setLoading(true);
        setErrStatus(0);
        if (aktivniFirma?.ic) {
            podaneZadostiApi('datumzmeny:desc', aktivniFirma.ic, 'zadostoisin', 6, 0, EStav.AKCEPTOVANO)
                .then(resp => setEmisePrehled(resp.zadosti ? resp.zadosti : []))
                .catch((err: any) => {
                    setErrStatus(err.response?.status);
                })
                .finally(() => setLoading(false));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refetchData]);

    return (
        <>
            {errStatus ? (
                <Row
                    justify="center"
                    align="middle"
                    style={{
                        height: '100%'
                    }}
                >
                    <Col span={16} flex={'0 0 auto'}>
                        {errStatus === 404 ? (
                            <Title text="ZADNE_EMISE" level={3} />
                        ) : errStatus ? (
                            <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                        ) : null}
                    </Col>
                </Row>
            ) : (
                <LoadingWrapper
                    loading={loading}
                    style={{
                        height: '100%'
                    }}
                >
                    <Title level={3} text="EMP_ISIN_DLAZDICE_NADPIS_SEZNAM" />
                    <Row gutter={16}>
                        {emisePrehled?.map((prehledEmise, i) => {
                            return (
                                <Col
                                    key={prehledEmise.id}
                                    span={12}
                                    style={{
                                        marginBottom: 16
                                    }}
                                >
                                    <Card
                                        className="dash-card"
                                        title={
                                            <Row
                                                style={{
                                                    height: 71
                                                }}
                                                align="middle"
                                            >
                                                <Paragraph
                                                    style={{
                                                        fontSize: 20,
                                                        marginRight: 4
                                                    }}
                                                    text={`EMISE_PODZAD_${
                                                        prehledEmise.typzadosti
                                                            ? prehledEmise.typzadosti.toUpperCase().split(' ').join('_')
                                                            : ''
                                                    }`}
                                                />

                                                {prehledEmise.druhcp && (
                                                    <div
                                                        style={{
                                                            fontSize: 20
                                                        }}
                                                    >
                                                        {'('}
                                                        <TranslateText>
                                                            {`ISIN_EMISE_DRUH_${prehledEmise.druhcp
                                                                .toUpperCase()
                                                                .split(' ')
                                                                .join('_')}`}
                                                        </TranslateText>
                                                        {')'}
                                                    </div>
                                                )}
                                            </Row>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'block',
                                                position: 'relative'
                                                // top: prehledEmise.druhcp ? 'initial' : 14
                                            }}
                                        >
                                            <Title text="AMLZ_PREHLED_DATUM" level={5} />
                                            <p>{dayjs(prehledEmise.datum).format(' DD.MM.YYYY')}</p>
                                            <Title text="EMP_PODANE_ZADOSTI_STAV" level={5} />
                                            <Paragraph
                                                text={`EMP_PODANE_ZADOSTI_${prehledEmise.stav
                                                    .toUpperCase()
                                                    .split(' ')
                                                    .join('_')}`}
                                            />
                                            <Row
                                                className="button-row"
                                                style={{
                                                    position: 'relative',
                                                    top: 14
                                                }}
                                            >
                                                {(prehledEmise.stav === EZadostStatus.AKCEPTOVANO ||
                                                    prehledEmise.stav === EZadostStatus.ZAMITNUTO ||
                                                    prehledEmise.stav === EZadostStatus.ODESLANO) && (
                                                    <ButtonComponent
                                                        id={`prehledEmiseStahnoutBtn${i}`}
                                                        buttontext={'STAHNOUT_PDF'}
                                                        onClick={() => {
                                                            setLoading(true);
                                                            identifikaceEmitenta('get', prehledEmise.id).then(data => {
                                                                if (data.redirect) {
                                                                    fileDownload(
                                                                        data.redirect,

                                                                        `${prehledEmise.id}_ZadostISIN.pdf`
                                                                    ).finally(() => setLoading(false));
                                                                }
                                                            });
                                                        }}
                                                    />
                                                )}
                                                {(prehledEmise.stav === EZadostStatus.KDOPLNENI ||
                                                    prehledEmise.stav === EZadostStatus.ROZPRACOVANO ||
                                                    prehledEmise.stav === EZadostStatus.KODESLANI) && (
                                                    <>
                                                        <ButtonComponent
                                                            buttontext={'POKRACOVAT'}
                                                            id={`prehledEmisePokracovatBtn${i}`}
                                                            onClick={() => {
                                                                setLoading(true);
                                                                identifikaceEmitenta(
                                                                    'get',
                                                                    prehledEmise.id,
                                                                    undefined,
                                                                    prehledEmise.typzadosti === ETypZadosti.REGI
                                                                        ? 'Registration'
                                                                        : undefined
                                                                )
                                                                    .then(data => {
                                                                        setLevel('isin', {
                                                                            ...data,
                                                                            idZadosti: prehledEmise.id,
                                                                            ...(prehledEmise.stav && {
                                                                                stav: prehledEmise.stav
                                                                            })
                                                                        });
                                                                        //  setTimeout(() => {
                                                                        navigateWorkaround(
                                                                            aktivniFirma
                                                                                ? prehledEmise.typzadosti ===
                                                                                  ETypZadosti.PRID
                                                                                    ? `/firma/${aktivniFirma?.iducet}${routePathEnum.EMISE_NOVY_ISIN}`
                                                                                    : prehledEmise.typzadosti ===
                                                                                        ETypZadosti.ZMEN
                                                                                      ? `/firma/${aktivniFirma?.iducet}${routePathEnum.EMISE_ZMENY_ISIN}`
                                                                                      : prehledEmise.typzadosti ===
                                                                                          ETypZadosti.ZRUS
                                                                                        ? `/firma/${aktivniFirma?.iducet}${routePathEnum.EMISE_ZRUSENI_ISIN}`
                                                                                        : prehledEmise.typzadosti ===
                                                                                            ETypZadosti.REGI
                                                                                          ? `/firma/${aktivniFirma?.iducet}${routePathEnum.EMISE_REGI_ISIN}`
                                                                                          : ''
                                                                                : ''
                                                                        );
                                                                        // }, 0);
                                                                    })
                                                                    .finally(() => setLoading(false));
                                                            }}
                                                        />
                                                        <ButtonComponent
                                                            id={`prehledEmiseZrusitBtn${i}`}
                                                            buttontext={'ZRUSIT_ZADOST'}
                                                            onClick={() => {
                                                                setLoading(true);
                                                                prehledEmise.typzadosti &&
                                                                    zruseniZadosti(
                                                                        prehledEmise.id,
                                                                        prehledEmise.typzadosti
                                                                    ).then(() => setRefetchData(val => !val));
                                                            }}
                                                        />
                                                    </>
                                                )}
                                                {(prehledEmise.stav === EZadostStatus.KDOPLNENI ||
                                                    prehledEmise.stav === EZadostStatus.ZAMITNUTO) && (
                                                    <ButtonComponent
                                                        style={{
                                                            marginBottom: 0
                                                        }}
                                                        id={`prehledEmiseVyjadreniBtn${i}`}
                                                        buttontext={'VYJADRENI_CDCP'}
                                                        onClick={() => {
                                                            setLoading(true);
                                                            vyjadreniCdcpIsinApi(prehledEmise.id)
                                                                .then(data => setModalMessage(data.vyjadreni))
                                                                .finally(() => setLoading(false));
                                                        }}
                                                    />
                                                )}
                                            </Row>
                                        </div>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                </LoadingWrapper>
            )}
            <Modal
                title={<TranslateText>{'VYJADRENI_CDCP'}</TranslateText>}
                open={!!modalMessage}
                onCancel={() => setModalMessage('')}
                afterClose={() => {
                    setModalMessage('');
                }}
                footer={
                    <Row className="button-row-modal">
                        <ButtonComponent
                            id="prehledEmiseZavritBtn"
                            buttontext="ZAVRIT"
                            onClick={() => {
                                setModalMessage('');
                            }}
                        />
                    </Row>
                }
            >
                <Row>
                    <Paragraph text={modalMessage} />
                </Row>
            </Modal>
        </>
    );
};

export default EmisePrehled;
